<template>
  <div class="wt-asset-editor-main-stage">
    <div class="wt-asset-editor-stage">
      <div class="wt-asset-editor-stage-effects">
        <slot />
      </div>
      <inner-stage :show-duration="showDuration" />
    </div>
  </div>
</template>

<script>
import InnerStage from 'AssetEditor/functionality/Stage/InnerStage.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    InnerStage,
  },

  props: {
    showDuration: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters('assetEditor', ['currentPage']),

    isGridEnabled() {
      return (
        this.currentPage.id === 'textOverlay' &&
        this.$store.getters.isGridEnabled
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-asset-editor-main-stage {
  border: 1px solid rgba(0, 0, 0, 0.2);
  grid-row: 2 / 3;
  grid-column: 2 / 3;
}
</style>
